<template>
  <div class="circle">
    <communityHeader :router_url='router_url'></communityHeader>

    <div class="contentWidth">
      <div class="location"><span>中经视觉社区</span>><span>圈子</span></div>
      <div class="accordion">
        <div v-show="loading">
          <loading style="margin-top:-80px"></loading>
        </div>
        <ul v-show="!loading">

          <li v-for="(li,index) in headuls"
              :key="index"
              :class="li.shows ? 'on':''"
              @mouseover="changeShow(index)">

            <!--当前 -->
            <div class="liActive">
              <router-link :to="'/circleDetail/'+li.id">
                <img :src="li.cover"
                     class="fade_image_out ">
              </router-link>
              <div class="bgtxt">{{li.description}}</div>

              <div class="mose"
                   v-if="!li.shows ">22222</div>
            </div>
          </li>

        </ul>
      </div>

      <!-- 圈子分类 -->
      <div class="circles mt20">
        <div class="hd">
          <ul class="of_h">
            <li :class="showlist==0?'fc_l on':'fc_l'"
                @click="change(0)">最新</li>
            <li :class="showlist==1?'fc_l on':'fc_l'"
                @click="change(1)">最热</li>

            <li v-for="(im,index) in selectCategory_list"
                :key="index"
                :class="showlist==index+2?'fc_l on':'fc_l'"
                @click="change(index+2,im.id)">{{im.name}}</li>

            <!-- 
            <li :class="showlist==2?'fc_l on':'fc_l'"
                @click="change(2)">经济</li>
            <li :class="showlist==3?'fc_l on':'fc_l'"
                @click="change(3)">纪实</li>
            <li :class="showlist==4?'fc_l on':'fc_l'"
                @click="change(4)">旅行</li>
            <li :class="showlist==5?'fc_l on':'fc_l'"
                @click="change(5)">美食</li>
            <li :class="showlist==6?'fc_l on':'fc_l'"
                @click="change(6)">摄影</li>
            <li :class="showlist==7?'fc_l on':'fc_l'"
                @click="change(7)">花卉</li> -->
          </ul>
        </div>
        <div class="bd clearfix">

          <div class="box">
            <div class="min_h_768 of_h">
              <div v-show="loading">
                <loading></loading>
              </div>

              <ul class="clearfix ul_ "
                  v-if="!loading && newhotdata.records!== undefined && newhotdata.records.length!==0">
                <router-link tag="li"
                             class="fc_l anmition_show"
                             v-for="(item,index) in newhotdata.records"
                             :key="index"
                             :to="'/circleDetail/'+item.id">
                  <img class="boxbg fade_image_out"
                       :src="item.cover"
                       style="object-fit: cover;">
                  <div class="Headimage"><img :src="item.logo"></div>
                  <div class="name">{{item.name}}</div>
                  <div class="info">{{item.description}}</div>
                  <div class="statistics">
                    <span class="state">成员<strong>{{item.userNum}}</strong></span>
                    <span class="middle">|</span>
                    <span class="state">作品<strong>{{item.topicNum}}</strong></span>
                  </div>
                  <div class="join"
                       v-if="item.code==0 ||item.code==null"
                       @click.stop="join(item.id,index)">加入圈子</div>
                  <div class="join join_dis hover_join"
                       v-if="item.code==1"
                       @click.stop="canceljoin(item.id,index)">
                    <p class="_width">已加入</p>
                    <p class="_width top">取消加入</p>
                  </div>

                </router-link>
              </ul>
              <div class="clearfix _width"
                   v-if="!loading && newhotdata.records!== undefined && newhotdata.records.length==0">
                <div class="null_data">
                  <img src="@/assets/image/common/null_data.png"
                       alt="">
                  <p>暂无数据...</p>
                </div>

              </div>

            </div>

            <div class="circlepage"
                 v-if="!loading ">
              <el-pagination background
                             :hide-on-single-page="true"
                             layout="prev, pager, next"
                             :current-page="parames.current"
                             @current-change="handleCurrentChange"
                             :page-size="parames.size"
                             :total="newhotdata.total"></el-pagination>

            </div>

          </div>

        </div>

      </div>
      <!-- 圈子分类 end-->

    </div>
  </div>
</template>
<script>
import communityHeader from '@/components/community/common/communityHeader.vue'
import loading from '@/components/loading/loading.vue'
import { selectCircleData } from '@/utils/api/communityCircle.js'
import { joinCircle, canceljoinCircle, selectCategory } from '@/utils/api/communityFind.js'

import { Info } from '@/utils/api/login.js'

export default {
  name: 'communitycircle',
  data () {
    return {
      loading: true,
      headuls: [],
      timer: null,
      showlist: 0,
      newhotdata: {},

      parames: {
        type: 1,
        categoryId: "",
        current: 1,
        size: 12,
      },
      this_code: 0,

      defaultImg: 'this.src="' + require('@/assets/image/common/loading.gif') + '"',//未加载
      error_login: require('@/assets/image/common/loading.gif'),
      selectCategory_list: [],//圈子类别
      this_active: 0,
    }
  },
  components: {
    communityHeader,
    loading
  },
  created () {
    this.is_login();//是否登陆
    this.router_url = this.$route.fullPath;//当前地址url

    this.getselectCircleData();  //进入页面获取头部数据
    this.getzselectCircleData(this.parames);//进入页面获取圈子数据
    this.selectCategory_data();//圈子列表
  },
  mounted () {
    //手风琴定时  
    let i = 0;
    let that = this;
    // console.log(that.headuls.length);
    that.timer = setInterval(() => {
      if (i < that.headuls.length - 1) { i++ } else { i = 0 }
      that.monitor(i)
    }, 3000)
  },

  methods: {
    // 圈子列表
    selectCategory_data () {
      selectCategory().then((res) => {
        let data = res.data;
        this.selectCategory_list = data.data
        // console.log(this.selectCategory_list);
      })
    },
    //切换圈子
    change (index, id) {
      this.showlist = index;
      console.log(index);
      if (index == 0) {
        this.parames.type = 1;
        this.parames.categoryId = "";
        this.parames.current = 1
        this.getzselectCircleData(this.parames)//切换加载数据
      }
      else if (index == 1) {
        this.parames.type = 2;
        this.parames.current = 1
        this.parames.categoryId = "";
        this.getzselectCircleData(this.parames)//切换加载数据
      }
      else if (index !== 0 && index !== 1) {
        this.parames.type = 0;
        this.parames.current = 1
        this.parames.categoryId = id;
        this.getzselectCircleData(this.parames)//切换加载数据
      }


    },
    // 是否登录
    is_login () {
      Info().then((res) => {
        let data = res.data;
        this.isLogin = data.isLogin
      })
    },


    //获取数据
    getzselectCircleData (parames) {
      this.loading = true;
      selectCircleData(this.parames).then((res) => {
        this.newhotdata = res.data.data;
        this.loading = false;
      })
    },
    //翻页
    handleCurrentChange (val) {
      window.scrollTo(0, 570);
      this.parames.current = val;
      this.getzselectCircleData(this.parames);

    },

    //头部手风琴开始
    changeShow (e) {
      this.timer = null;
      if (!this.headuls) { return };
      this.headuls.forEach((item, index) => {
        if (e == index) {
          item.shows = true;
          this.$set(this.headuls, index, item);
        } else {
          item.shows = false;
          this.$set(this.headuls, index, item)
        }
      });
      this.monitor(e);
    },

    monitor (aindex = 0) {
      if (this.headuls.length == 0) {
        this.loading = true;
      } else {
        this.loading = false;
        this.headuls.forEach((item, index) => {
          item.shows = false;
          this.$set(this.headuls, index, item)
        });
        this.headuls[aindex].shows = true;
        this.$set(this.headuls, aindex, this.headuls[aindex])
      }

    },
    //头部手风琴结束

    //头部数据
    getselectCircleData () {
      selectCircleData().then((res) => {
        let data = res.data
        this.loading = false;
        this.headuls = data.data.records.slice(0, 5);
        console.log();
        if (!this.headuls) { return }
        this.headuls.forEach((item) => {
          item.shows = false;
        });
        this.headuls[0].shows = true
      })
    },

    //取消加入
    canceljoin (id, index) {
      // 未登录就去登录
      if (this.isLogin == true) {
        canceljoinCircle({
          circleId: id,
        }).then(res => {

          if (res.data.code == 200) {
            this.$message({
              message: '取消加入圈子成功！',
              center: true,
              type: 'success'
            });
            // this.newhotdata.records[index].code = 1
            this.getzselectCircleData(this.parames)
          } else {
            this.$message({
              message: res.data.message,
              center: true,
              type: 'error'
            });
          }
        })
      } else {
        sessionStorage.setItem('router_url', this.router_url)//活动详情
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }

    },
    //加入圈子
    join (id, index) {
      // 未登录就去登录
      if (this.isLogin == true) {
        let parmes = {
          circleId: id,
        };
        joinCircle(parmes).then((res) => {
          if (res.data.code !== 200) {
            this.$message({
              message: res.data.message,
              center: true,
              type: 'error'
            });
            // this.getzselectCircleData(this.parames)
          } else {
            this.$message({
              message: '加入圈子成功！',
              center: true,
              type: 'success'
            });
            this.newhotdata.records[index].code = 1
            this.getzselectCircleData(this.parames)
          }
        })
      } else {
        sessionStorage.setItem('router_url', this.router_url)//活动详情
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }
    }
  },

  destroyed () {
    this.timer = null
  }
}
</script>
<style lang="scss" scoped="scoped">
@import "../../assets/css/community/communityCircle";

.min_h_768 {
  padding-bottom: 50px;
}
.circlepage {
  padding: 0px 0 50px !important;
}
.join p {
  height: 100%;
  line-height: 0.28rem;
}
.hover_join {
  position: relative;
  overflow: hidden;
}
.hover_join p {
  color: #333 !important;
}
.top {
  top: 0.28rem;
  transition: all 0.3s;
}
.hover_join:hover .top {
  position: absolute;
  top: 0;
  background: #fafafa;
  color: #d3011a !important;
}
</style>



// WEBPACK FOOTER //
// src/views/community/communityCircle.vue